// extracted by mini-css-extract-plugin
module.exports = {"orange":"#EE7B0C","orange100":"#fce5ce","orange300":"#f5b06d","orange900":"#8f4a07","white":"#FFFFFF"};